/**
 * rw-landing.js — Restwell Landing Page Scroll Behavior
 *
 * - IntersectionObserver to pause/play videos in off-screen sections
 * - Scroll reveal animation (.rw-reveal → .is-visible)
 * - Hero scroll indicator click handler
 */
(function () {
  'use strict';

  /* ── Video pause/play via IntersectionObserver ── */
  function initVideoObserver() {
    var videos = document.querySelectorAll('.rw-video-bg video');
    if (!videos.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  /* ── Scroll reveal animation ── */
  function initReveal() {
    var reveals = document.querySelectorAll('.rw-reveal');
    if (!reveals.length) return;

    var prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      reveals.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    reveals.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Scroll indicators (hero + all sections) ── */
  function initScrollIndicators() {
    var indicators = document.querySelectorAll(
      '.rw-hero__scroll, .rw-scroll-indicator'
    );

    indicators.forEach(function (indicator) {
      indicator.addEventListener('click', function () {
        var section = indicator.closest('.shopify-section');
        if (!section) return;
        var next = section.nextElementSibling;
        if (next) {
          next.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  /* ── Init ── */
  function init() {
    initVideoObserver();
    initReveal();
    initScrollIndicators();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
